import React, { useEffect, useState, useCallback, useRef } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { toast } from 'react-toastify';
import { getSessionId } from '../utils/sessionId';
import Calculator from './Calculator';
import LoyaltyPoints from './LoyaltyPoints';
import { useNavigate } from 'react-router-dom';
import AddSelectCustomerModal from './modals/AddSelectCustomerModal';
import ApplyVoucherModal from './modals/ApplyVoucherModal';
import ApplyDiscountModal from './modals/ApplyDiscountModal';
import { isOfflineAndroid } from '../utils/androidOfflineCart';
import { getOfflineCheckoutSummary} from '../utils/offlineCheckout';
import { markOfflineOrderPaid, markOfflineTablePaid } from '../utils/offlinePayment';


export default function CheckoutSummary({
  PAYMENT_MODES,
  orderTypeNum,
  orderId,
  tableId = null,
  resumingUnpaidOrder = false,
  selectedOffer,
  paymentMethod,
  setPaymentMethod,
  selectedTender,
  selectedCartItems = [],
  onEftposRequest = () => { },
  onPaymentSuccess,
  onPaymentComplete = null,
  onBillingConfigChange = null,
  onDigitalReceiptConfigChange = null,
  onSummaryReady = null,
  splitPaymentActive = false,
  setUuid,
  setAmount,
  splitType,
  splitCount,
  cashAmount,
  cashEftposMode = false,
  setSplitPaymentActive,
  setSplitType,
  setSplitCount,
  setFreezeSplitControls,
  isPrepaid,
  orderName
}) {
  const navigate = useNavigate();
  const [checkoutSummary, setCheckoutSummary] = useState(null);
  const [loading, setLoading] = useState(false);
  const [offerId, setOfferId] = useState(null);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [loyaltyApplied, setLoyaltyApplied] = useState(false);
  const [loyaltyAmount, setLoyaltyAmount] = useState(0);
  const [coupon, setCoupon] = useState('');
  const [couponApplying, setCouponApplying] = useState(false);
  const [couponMessage, setCouponMessage] = useState('');
  const [showVoucherModal, setShowVoucherModal] = useState(false);
  const [showDiscountModal, setShowDiscountModal] = useState(false);
  // A manual discount and an Offer/voucher are mutually exclusive - applying one clears the
  // other, the same implicit exclusivity Promotion and Coupon already have by sharing offerId.
  const [manualDiscountType, setManualDiscountType] = useState(null);
  const [manualDiscountValue, setManualDiscountValue] = useState(null);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [gratuitySurchargeId, setGratuitySurchargeId] = useState(null);
  const gratuitySurchargeIdRef = useRef(null);
  const hasAutoSelectedGratuity = useRef(false);
  useEffect(() => {
    gratuitySurchargeIdRef.current = gratuitySurchargeId;
  }, [gratuitySurchargeId]);

  // Default Gratuity to selected so staff opt OUT if the customer doesn't
  // want it, rather than having to opt in. Only auto-select once, so it
  // doesn't override a staff member's explicit choice to deselect it later.
  useEffect(() => {
    if (hasAutoSelectedGratuity.current) return;
    const firstGratuityOption = checkoutSummary?.gratuity_surcharges?.[0];
    if (firstGratuityOption) {
      hasAutoSelectedGratuity.current = true;
      setGratuitySurchargeId(firstGratuityOption.id);
    }
  }, [checkoutSummary?.gratuity_surcharges]);

  const restaurantName = localStorage.getItem("restaurant_name");

  const showPayTom =
    ["Demo Restaurant", "Napoli Restaurant"].includes(restaurantName);

  useEffect(() => {
    setOfferId(selectedOffer?.id || null);
    if (selectedOffer?.id) {
      setManualDiscountType(null);
      setManualDiscountValue(null);
    }
  }, [selectedOffer]);

  const nativeLog = (msg) => {
    window.AndroidPOS?.logWeb?.(msg);
  };

  const handleTomPayment = async () => {
    try {
      nativeLog("WEB_PAYMENT_CLICKED");
      const res = await callAPI(
        apiUrls.TOM_INITIATE,
        {},
        "POST",
        {
          order_id: orderId,
          table_id: tableId
        }
      );
      const sessionId = res?.data?.data?.session_id;
      nativeLog("SESSION_ID_RECEIVED: " + sessionId);
      console.log("eftposssee",sessionId);
        if (!sessionId) {
          
        toast.error("Failed to initiate payment");
        return;
      }
      nativeLog("API_TOM_INITIATE_CALLED");
      window.AndroidPOS?.startPayment(
        checkoutSummary?.net_total
          ? Math.round(checkoutSummary.net_total * 100)
          : 0,
        sessionId 
      );
    } catch (err) {
      console.error(err);
      toast.error("Payment initiation failed");
    }
  };

  const downloadTomReport = () => {
    window.AndroidPOS?.downloadTomDebugReport?.();
  };


  useEffect(() => {
    window.onWorldlinePaymentResult = async (response) => {
    //  alert("Payment callback received");
      console.log("RAW RESPONSE:", response);
      nativeLog("PAYMENT_CALLBACK_RECEIVED_RAW_RESPONSE"+response);
  
      try {
  
        const data =
          typeof response === "string"
            ? JSON.parse(response)
            : response;
  
        console.log("PARSED RESPONSE:", data);
  
        nativeLog("PARSED_RESPONSE: " + JSON.stringify(data));
       // alert(JSON.stringify(data, null, 2));
  
        if (
          data?.isoResponseCode === "00" ||
          data?.result === "WPI_RESULT_SUCCESS"
        ) {
  
          toast.success("Payment Successful");
  
          console.log("SUCCESS RESPONSE:", data);
  
          try {
            const res =  await callAPI(
              apiUrls.ORDER_PAYMENT,
              {},
              "POST",
              {
                order_id: orderId,
                table_id: tableId,
                payment_mode: PAYMENT_MODES.eftpos,
                paid: 1,
                tom_response: data,
                pos_type:"TapOnMobile",
                resuming_unpaid_order: resumingUnpaidOrder ? 1 : 0,
                ...(gratuitySurchargeIdRef.current ? { gratuity_surcharge_id: gratuitySurchargeIdRef.current } : {})
              }
            );
  
           // toast.success("Order marked as paid");
  
           // onPaymentSuccess?.();
           if (res?.data?.status == 1) {
            toast.success(res.data.message || 'Payment successful');
            toast.success("Order marked as paid");
            const apiActionRedirect = res?.data?.action === 'redirect';
            const allPaid =
              res?.data?.data?.all_item_paid === true ||
              res?.data?.all_item_paid === true;
    
            if (apiActionRedirect || allPaid) {
              navigate('/dashboard');
             // just for testing so that can download log
            } else {
              onPaymentSuccess();
              await fetchCheckoutSummary();
            }
            return;
          } else {
            toast.error(res?.data?.message || 'Payment failed');
          }

  
          } catch (apiErr) {
  
            console.error("Backend API Error:", apiErr);
  
            toast.error("Payment success but backend update failed");
          }
  
          return;
        }
  
    
        if (data?.result === "WPI_RESULT_FAILURE") {
  
          const msg =
            data?.remark ||
            data?.errorCondition ||
            "Payment Failed";
  
          toast.error(msg);
  
          console.log("FAILURE RESPONSE:", data);
  
          return;
        }
        toast.error("Unknown payment response");
        console.log("UNKNOWN RESPONSE:", data);
  
      } catch (e) {
        console.error("Payment Parse Error:", e);
        toast.error("Invalid payment response");
      }
    };
  
    return () => {
      delete window.onWorldlinePaymentResult;
    };
  
  }, []);

  useEffect(() => {
    setOfferId(null);
    setCoupon('');
    setCouponMessage('');
    setManualDiscountType(null);
    setManualDiscountValue(null);
    // Gratuity is intentionally left as-is on payment method change - staff
    // unselect it manually if needed, it shouldn't reset automatically.
  }, [paymentMethod]);

  useEffect(() => {
    const resumeLinklyPayment = async () => {
      if (!orderId && !tableId) return;
  
      try {
        const payload = {};
        if (orderId) payload.order_id = orderId;
        if (tableId) payload.table_id = tableId;
  
        // withLoader=false - this is a background check for an in-progress
        // payment to resume, not a core piece of the checkout page itself.
        const res = await callAPI(
          apiUrls.CHECK_LAST_LINKLY_PAYMENT,
          {},
          'POST',
          payload,
          {},
          {},
          false
        );
  
        const linkly = res?.data;
  
        
        if (linkly?.status === 1 && linkly?.uuid) {
          window.dispatchEvent(
            new CustomEvent('eftpos-payment-linkly', {
              detail: {
                uuid: linkly.uuid,
                amount: linkly.amount
              }
            })
          );
  
          setUuid(linkly.uuid);
          setAmount(linkly.amount);
  
          toast.info('Resuming EFTPOS payment');
        }
      } catch (err) {
        console.error('Linkly resume failed', err);
      }
    };
  
    
    if (checkoutSummary?.linkly?.length > 0) {
      resumeLinklyPayment();
    }
  
  }, [orderId, tableId, checkoutSummary?.linkly]);

const fetchCheckoutSummary = useCallback(async () => {
  setLoading(true);

  try {
      console.log(
          '[BEFORE_OFFLINE_SUMMARY] BeforeCheckoutSummary OFFLINE MODE'
        );
      if (isOfflineAndroid()) {

        console.log(
          '[OFFLINE_SUMMARY] CheckoutSummary OFFLINE MODE'
        );

        console.log(
          '[OFFLINE_SUMMARY] Props:',
          {
            tableId,
            orderId
          }
        );

        const summary = await getOfflineCheckoutSummary({
            tableId,
            localOrderId: orderId
          });

        console.log(
          '[OFFLINE_SUMMARY] ===== SUMMARY RECEIVED IN CHECKOUT SUMMARY =====',
          JSON.stringify(
            summary,
            null,
            2
          )
        );

        setCheckoutSummary(summary);

        console.log(
          '[OFFLINE_SUMMARY] setCheckoutSummary CALLED'
        );

        if (onBillingConfigChange) {
          onBillingConfigChange(
            !!summary.pos_billing_print_prompt
          );
        }

        if (onDigitalReceiptConfigChange) {
          onDigitalReceiptConfigChange(
            !!summary.pos_digital_receipt_enabled
          );
        }

        if (onSummaryReady) {
          onSummaryReady(summary);
        }

        window.dispatchEvent(
          new CustomEvent("total-due-amount", {
            detail: {
              total: summary.net_total,
              order_type: summary.order_type
            }
          })
        );

        return;
      }



    const payload = {
      payment_method: paymentMethod ?? PAYMENT_MODES.cod,
      session_id: getSessionId(),
      loyalty_applied: loyaltyApplied,
      loyalty_amount: loyaltyAmount
    };

    if (selectedTender) payload.tender = selectedTender;
    if (offerId) payload.offer_id = offerId;
    if (manualDiscountType && manualDiscountValue) {
      payload.manual_discount_type = manualDiscountType;
      payload.manual_discount_value = manualDiscountValue;
    }
    if (orderId) payload.order_id = orderId;
    if (gratuitySurchargeId) payload.gratuity_surcharge_id = gratuitySurchargeId;
    if (selectedCartItems.length > 0)
      payload.selecteditem = selectedCartItems.join(',');

    if (splitPaymentActive) {
      // "Cash + EFTPOS" has no backend concept of its own - it's a 2-way equal split with a
      // staff-entered (not equal) first amount, so the wire payload always says 'equal' here.
      // See the same translation in handlePayment()'s payload below.
      payload.split_type = splitType === "cash_eftpos" ? "equal" : splitType;

      if (splitType === "equal" && splitCount > 0) {
        payload.split_count = splitCount;
      } else if (splitType === "cash_eftpos") {
        payload.split_count = 2;
      }
    }

    let url = apiUrls.CHECKOUT_SUMMARY_DETAILS;
    if (tableId) url += `?table_id=${tableId}`;
    else if (orderId) url += `?order_id=${orderId}`;

    const res = await callAPI(url, {}, "POST", payload);

    const rawSummary = res?.data?.data;
    if (!rawSummary) return;


    let summary = { ...rawSummary };


    if (Array.isArray(summary.split_payment)) {
      summary.split_payment = null;
    }

    if (typeof summary.order_number === "string") {
      summary.order_number = summary.order_number.split(" ");
    }

    setCheckoutSummary(summary);
    if (onBillingConfigChange) onBillingConfigChange(!!summary.pos_billing_print_prompt);
    if (onDigitalReceiptConfigChange) onDigitalReceiptConfigChange(!!summary.pos_digital_receipt_enabled);
    if (onSummaryReady) onSummaryReady(summary);

    const backendSplit = summary.split_payment;

    const hasRealSplitStarted =
      backendSplit &&
      backendSplit.history &&
      backendSplit.history.some(
        (sp) => Number(sp.payment_amount) > 0
      );

    if (hasRealSplitStarted) {
      setSplitPaymentActive(true);
      
      if (backendSplit.split_type) {
        setSplitType(backendSplit.split_type);
      }

      if (backendSplit.split_count) {
        setSplitCount(backendSplit.split_count);
      }
      setFreezeSplitControls(true);
    } else {
      setFreezeSplitControls(false);
    }

    window.dispatchEvent(
      new CustomEvent("total-due-amount", {
        detail: {
          total: summary.net_total,
          order_type: summary.order_type
        }
      })
    );

  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch checkout summary");
  } finally {
    setLoading(false);
  }
}, [
  paymentMethod,
  selectedTender,
  offerId,
  manualDiscountType,
  manualDiscountValue,
  orderId,
  tableId,
  selectedCartItems,
  loyaltyApplied,
  loyaltyAmount,
  splitPaymentActive,
  splitType,
  splitCount,
  gratuitySurchargeId
]);
  useEffect(() => {
    //paymentMethodn if null, don't fetch summary yet, wait for the real value to be set
    // Wait for the real value instead of racing it.
    if (paymentMethod == null) return;
    fetchCheckoutSummary();
  }, [fetchCheckoutSummary, paymentMethod]);

  const handleApplyCoupon = async () => {
    //if (checkoutSummary?.split_payment?.current) {
    if (hasSplitPayment) { 
      toast.error('Cannot apply coupon during split payment');
      return;
    }

    if (!coupon) {
      toast.error('Please add a coupon');
      return;
    }

    setCouponApplying(true);
    try {
      const payload = {
        voucher: coupon,
        payment_method: paymentMethod,
      };

      if (tableId) payload.table_id = tableId;
      else if (orderId) payload.order_id = orderId;

      const res = await callAPI(
        apiUrls.VOUCHER_VALIDITY,
        {},
        'POST',
        payload
      );

      if (!res?.data?.valid) {
        toast.error('Invalid coupon');
        return;
      }

      
      setOfferId(res.data.valid.id);
      setCouponMessage(res.data.valid.message || 'Coupon applied');
      // Mutually exclusive with a manual discount - a voucher replaces it, not stacks with it.
      setManualDiscountType(null);
      setManualDiscountValue(null);

      setLoyaltyApplied(false);
      setLoyaltyAmount(0);

      toast.success('Coupon applied');
      setShowVoucherModal(false);
      fetchCheckoutSummary();

    } catch (err) {
      console.error(err);
      toast.error('Coupon validation failed');
    } finally {
      setCouponApplying(false);
    }
  };

  const handleApplyManualDiscount = (type, value) => {
    if (hasSplitPayment) {
      toast.error('Cannot apply discount during split payment');
      return;
    }

    // Mutually exclusive with Promotion/Coupon - clear those so only one discount source is active.
    setOfferId(null);
    setCoupon('');
    setCouponMessage('');

    setManualDiscountType(type);
    setManualDiscountValue(value);

    toast.success('Discount applied');
    setShowDiscountModal(false);
    fetchCheckoutSummary();
  };

  const allItemPaid = checkoutSummary?.all_item_paid === true;
  const showCalculator = paymentMethod === PAYMENT_MODES.cod;
  const showPayNow = paymentMethod !== PAYMENT_MODES.eftpos && !allItemPaid;
  const showEftposButtons =
  paymentMethod === PAYMENT_MODES.eftpos &&
  checkoutSummary?.linkly?.length > 0 &&
  !allItemPaid;
  const showUnpaid = !allItemPaid && orderTypeNum !== 3;
  const showCompleteOrder = allItemPaid;
  // const hasSplitPayment = checkoutSummary?.split_payment &&
  //   (checkoutSummary.split_payment.history?.length > 0 || checkoutSummary.split_payment.current);
  // Before the first "Cash + EFTPOS" payment, the backend has nothing persisted yet and would
  // otherwise show an equal-share preview (since the wire payload already says split_type:
  // 'equal', split_count: 2 - see fetchCheckoutSummary) that doesn't match the cash amount staff
  // are about to type - the cash_eftpos preview block below is what shows instead. Once the first
  // payment lands, fetchCheckoutSummary's split_type sync flips local splitType to 'equal' (what
  // the backend actually persisted), so this exclusion stops applying and the real Paid/Paying
  // Now amounts render via the existing equal-split UI below.
  const hasSplitPayment = splitType !== 'cash_eftpos' && checkoutSummary?.split_payment &&
    (
      (checkoutSummary.split_payment.history?.some(sp => Number(sp.payment_amount) > 0)) ||
      (checkoutSummary.split_payment.current?.total_amonut > 0)
    );

  const perSplitAmount =
    checkoutSummary?.split_payment?.current?.total_amonut || 0;

  const splitsPaidCount = checkoutSummary?.split_payment?.history?.length || 0;
  const totalSplitPaid = (checkoutSummary?.split_payment?.history || [])
    .reduce((sum, sp) => sum + (Number(sp.payment_amount) || 0), 0);
  const splitRemainingBalance = Math.max(
    0,
    (Number(checkoutSummary?.net_total) || 0) - totalSplitPaid
  );

  // "Cash + EFTPOS" locks which tender each of its two splits uses (that's the whole point of
  // the mode), so staff shouldn't have to remember to switch the payment-method button
  // themselves between the two: the first split is always cash, the second always EFTPOS.
  useEffect(() => {
    if (!splitPaymentActive || !cashEftposMode || !setPaymentMethod) return;
    setPaymentMethod(splitsPaidCount >= 1 ? PAYMENT_MODES.eftpos : PAYMENT_MODES.cod);
  }, [splitPaymentActive, cashEftposMode, splitsPaidCount, setPaymentMethod, PAYMENT_MODES]);

  const handleEftposPay = async (pinpad) => {
   // if (checkoutSummary?.split_payment?.current && selectedCartItems.length === 0) {
    if (hasSplitPayment && selectedCartItems.length === 0) {
      toast.warning('Please select items for split payment');
      return;
    }
  
    try {
      setPaymentProcessing(true);
      
      window.dispatchEvent(
        new CustomEvent('eftpos-payment-linkly', {
          detail: {
            uuid: null,
            amount: checkoutSummary?.net_total || 0,
            loading: true
          }
        })
      );

        const payload = {
        payment_mode: PAYMENT_MODES.eftpos,
        order_id: orderId,
        table_id: tableId,
        tender: selectedTender,
        pinpad_id: pinpad.id,
        paid:1,
        windcave_id: pinpad.id,
        resuming_unpaid_order: resumingUnpaidOrder ? 1 : 0
      };
      if (isPrepaid) {
        payload.isPrepaid = 1;
      }
      if (gratuitySurchargeId) {
        payload.gratuity_surcharge_id = gratuitySurchargeId;
      }
        // split logic
      if (selectedCartItems?.length > 0) {
        payload.payable_cart_items = JSON.stringify(selectedCartItems);
      }
  
      if (splitPaymentActive) {
        payload.split_type = splitType;
  
        if (splitType === "equal") {
          payload.split_count = splitCount;
          payload.split_amount = perSplitAmount;
        }
      }
  
      const url = splitPaymentActive
        ? apiUrls.CART_ORDER_PAYMENT
        : apiUrls.ORDER_PAYMENT;
  
      const res = await callAPI(url, {}, 'POST', payload);
      const data = res?.data;
        if (data?.action === 'redirect') {
        window.location.href = '/home';
        return;
      }
      if (data?.status == 0) {
        window.dispatchEvent(
          new CustomEvent('eftpos-payment-linkly', {
            detail: {
              error: data?.message || 'EFTPOS failed'
            }
          })
        );
        return;
      }
      if (data?.status == 1 || data?.code == 202) {
        if (data?.data?.uuid) {
          window.dispatchEvent(
            new CustomEvent('eftpos-payment-linkly', {
              detail: {
                uuid: data.data.uuid,
                amount: checkoutSummary?.net_total
              }
            })
          );
          return;
        }
      
        if (data?.cart_payment_id) {
          toast.success(data.message || 'Payment successful');
          onPaymentSuccess?.();
          window.dispatchEvent(
            new CustomEvent('eftpos-payment-result', {
              detail: {
                status: 'success',
                message: data?.message
              }
            })
          );  
          return;
        }
      }
      
      
      
      toast.error(data?.message || 'EFTPOS failed');
  
    } catch (err) {
      console.error(err);
      toast.error('EFTPOS error');
    } finally {
      setPaymentProcessing(false);
    }
  };


  const handlePayment = async (paid,manualeftpos = false) => {
    if (!paymentMethod) {
      toast.error('Please select a payment method');
      return;
    }

    // =====================================================
    // OFFLINE ANDROID CASH PAYMENT
    // =====================================================

    if (
      isOfflineAndroid() &&
      paymentMethod === PAYMENT_MODES.cod &&
      !manualeftpos
    ) {

     
      setPaymentProcessing(true);

      try {

        console.log(
          "[OFFLINE_PAYMENT] Starting cash payment",
          {
            localOrderId: orderId
          }
        );

      let result;
       if (tableId != null) {
        // Pay all open orders for this dine-in table.
         result = await markOfflineTablePaid(tableId);
      } else {
        // Pay one individual order.
        if (!orderId) {
          toast.error("Offline order ID is missing");
          return;
        }

         result = await markOfflineOrderPaid(orderId);
      }



        console.log(
          "[OFFLINE_PAYMENT] Payment result",
          result
        );

        if (!result?.success) {

          toast.error(
            result?.error ||
            "Failed to mark order as paid"
          );

          return;
        }

        toast.success(
          "Payment successful"
        );

        // Order is now PAID in Room.
        if (onPaymentComplete) {

          onPaymentComplete(
            !!checkoutSummary?.pos_billing_print_prompt
          );

        } else {

          navigate('/dashboard');

        }

        return;

      } catch (err) {

        console.error(
          "[OFFLINE_PAYMENT] Error",
          err
        );

        toast.error(
          err?.message ||
          "Offline payment failed"
        );

        return;

      } finally {

        setPaymentProcessing(false);
      }
    }
      
    if (splitPaymentActive) {
      const cashAmountNum = Number(cashAmount);
      if (
        (splitType === "item" && selectedCartItems.length === 0) ||
        (splitType === "equal" && perSplitAmount <= 0) ||
        (splitType === "cash_eftpos" && (
          !cashAmount || cashAmountNum <= 0 || cashAmountNum >= (checkoutSummary?.net_total || 0)
        ))
      ) {
        toast.warning(
          splitType === "item"
            ? "Split payment is enabled. Please select item(s)."
            : splitType === "cash_eftpos"
              ? "Enter a cash amount greater than $0 and less than the total."
              : "Split payment is enabled. Amount must be greater than 0."
        );
        return;
      }
    }
    setPaymentProcessing(true);
    try {
      const payload = {
        payment_mode: manualeftpos ? PAYMENT_MODES.eftpos : paymentMethod,
        paid,
        offer_id: offerId,
     //   payable_cart_items: JSON.stringify(selectedCartItems),
        order_id: orderId,
        table_id: tableId,
        tender: selectedTender,
        manual_eftpos: manualeftpos ? 1 : 0,
        resuming_unpaid_order: resumingUnpaidOrder ? 1 : 0,
      };
      if (manualDiscountType && manualDiscountValue) {
        payload.manual_discount_type = manualDiscountType;
        payload.manual_discount_value = manualDiscountValue;
      }
      if (gratuitySurchargeId) {
        payload.gratuity_surcharge_id = gratuitySurchargeId;
      }
      if (isPrepaid) {
        payload.isPrepaid = 1;
      }
      if (selectedCartItems && Array.isArray(selectedCartItems) && selectedCartItems.length > 0) {
        payload.payable_cart_items = JSON.stringify(selectedCartItems);
      }
      if (splitPaymentActive) {
        // "Cash + EFTPOS" only exists as a wire concept for the very first payment - by the
        // second payment, fetchCheckoutSummary's split_type sync (see hasRealSplitStarted below)
        // has already flipped local splitType to 'equal' once the backend persists it, so this
        // branch only ever runs once per order.
        if (splitType === "cash_eftpos") {
          payload.split_type = "equal";
          payload.split_count = 2;
          payload.split_amount = Number(cashAmount);
        } else {
          payload.split_type = splitType;

          if (splitType == "equal") {
            payload.split_count = splitCount;
            payload.split_amount = perSplitAmount;
          }
        }
      }
      console.log("FINAL PAYLOAD >>>", payload);

      //const url = selectedCartItems.length > 0 ? apiUrls.CART_ORDER_PAYMENT : apiUrls.ORDER_PAYMENT;
      const url = splitPaymentActive ? apiUrls.CART_ORDER_PAYMENT : apiUrls.ORDER_PAYMENT;
      const res = await callAPI(url, {}, 'POST', payload);



      if (paymentMethod === PAYMENT_MODES.eftpos && res?.data?.data?.uuid) {
        window.dispatchEvent(new CustomEvent('eftpos-payment-linkly', {
          detail: { uuid: res.data.data.uuid, amount: res.data.data.amount }
        }));
        return;
      }

      if (
        paymentMethod === PAYMENT_MODES.online &&
        res?.data?.data?.redirect_url
      ) {
        window.location.href = res.data.data.redirect_url;
        return;
      }

      if (res?.data?.status === 1) {
        toast.success(res.data.message || 'Payment successful');
        const apiActionRedirect = res?.data?.action === 'redirect';
        const allPaid =
          res?.data?.data?.all_item_paid === true ||
          res?.data?.all_item_paid === true;

        if (apiActionRedirect || allPaid) {
          onPaymentComplete ? onPaymentComplete(!!checkoutSummary?.pos_billing_print_prompt) : navigate('/dashboard');
        } else {
          onPaymentSuccess();
          await fetchCheckoutSummary();
        }
        return;
      } else {
        toast.error(res?.data?.message || 'Payment failed');
      }
    } catch (err) {
      console.error(err);
      toast.error('Payment failed');
    } finally {
      setPaymentProcessing(false);
    }
  };


  const handlePrintBill = async () => {
    try {
      const payload = { order_id: orderId };
      if (tableId) payload.table_id = tableId;
      if(paymentMethod) payload.payment_mode = paymentMethod;
      if (gratuitySurchargeId) payload.gratuity_surcharge_id = gratuitySurchargeId;
      await callAPI(apiUrls.PRINT_BILL, {}, 'POST', payload);
      toast.success('Bill printed');
    } catch {
      toast.error('Print failed');
    }
  };


  const OrderInfo = () => (
    <>
      <div className="sbRow">
        <span className="lbl">Order #</span>
        <span className="val" style={{ display: "flex", flexWrap: "wrap" }}>{checkoutSummary?.order_number?.map((n, i) => <span key={i} className="me-1">{n}</span>)}</span>
      </div>
      {checkoutSummary?.table?.name && (
        <div className="sbRow">
          <span className="lbl">{checkoutSummary.table.is_pager ? 'Pager #' : 'Table Name #'}</span>
          <span className="val">{checkoutSummary.table.name}</span>
        </div>
      )}
      <div className="sbRow flex-nowrap">
        <span className="lbl">Customer</span>
        <span className="val d-inline-flex flex-wrap gap-2 align-items-center">{orderName || checkoutSummary?.customer_name || 'Guest'}
          <svg width="20" height="20" class="customerEditIcon d-block" onClick={() => setShowCustomerModal(true)}>
            <use xlinkHref="./images/sprite.svg#iconEdit"></use>
          </svg>
        </span>
      </div>
      <div className="sbRow"><span className="lbl">Subtotal</span><span className="val">${checkoutSummary?.gross_total}</span></div>
      
      {checkoutSummary?.loyalty_discount > 0 && (
        <div className="sbRow">
          <span className="lbl">Loyalty Discount</span>
          <span className="val text-danger">- ${checkoutSummary.loyalty_discount}</span>
        </div>
      )}
      {checkoutSummary?.global_surcharges?.map((s, i) => (
        <div key={i} className="sbRow">
          <span className="lbl">{s.charge_name}</span>
          <span className="val">{s.total_expenses}</span>
        </div>
      ))}
      {checkoutSummary?.delivery_fee > 0 && (
        <div className="sbRow">
          <span className="lbl">
            Delivery Fee
            {checkoutSummary?.delivery_distance > 0 && (
              <small className="d-block text-muted">
                ({checkoutSummary.delivery_distance / 1000} kms)
              </small>
            )}
          </span>
          <span className="val">${checkoutSummary.delivery_fee}</span>
        </div>
      )}

      {checkoutSummary?.offer_discount > 0 && (
        <div className="sbRow">
          <span className="lbl">Promo ({checkoutSummary.offer_name})</span>
          <span className="val text-danger">- ${checkoutSummary.offer_discount}</span>
        </div>
      )}
      {checkoutSummary?.manual_discount > 0 && (
        <div className="sbRow">
          <span className="lbl">
            Manual Discount ({checkoutSummary.manual_discount_type === 'percent'
              ? `${checkoutSummary.manual_discount_value}%`
              : `$${checkoutSummary.manual_discount_value}`})
            {' '}
            <button
              type="button"
              className="btn btn-link p-0"
              style={{ fontSize: '0.75rem' }}
              onClick={() => {
                setManualDiscountType(null);
                setManualDiscountValue(null);
              }}
            >
              Remove
            </button>
          </span>
          <span className="val text-danger">- ${checkoutSummary.manual_discount}</span>
        </div>
      )}
      <hr />
      <div className="sbRow flex-nowrap mdText">
        <span className="lbl primaryColor fw-semibold">Total</span>
        <span className="val">${checkoutSummary?.net_total}</span>
      </div>
    </>
  );

  const SplitPayments = () => (
    hasSplitPayment ? (
      <>
        <hr />
        <div className="pSplitCol">
          <h4 className="xsTitle mb-2 pb-0">Split Payments Details</h4>

          {/* Equal split: one unified, ordered list — every split's status (Paid / Paying Now /
              Pending) is visible at a glance instead of scattered across separate blocks. */}
          {splitType === 'equal' && splitCount > 0 && (
            <div className="equalSplitSelection">
              {Array.from({ length: splitCount }).map((_, i) => {
                const paidEntry = checkoutSummary.split_payment.history?.[i];
                const isPaid = !!paidEntry;
                const isActive = !isPaid && i === splitsPaidCount;
                const amount = isPaid ? paidEntry.payment_amount : perSplitAmount;
                const status = isPaid ? 'paid' : isActive ? 'active' : 'pending';

                return (
                  <div key={i} className={`splitStatusRow ${status}`}>
                    <span className="splitStatusLabel">
                      <span className={`splitStatusBadge ${status}`}>
                        {isPaid ? 'Paid' : isActive ? 'Paying Now' : 'Pending'}
                      </span>
                      <span>
                        {cashEftposMode && splitCount === 2
                          ? (i === 0 ? 'Cash' : 'EFTPOS')
                          : `Split ${i + 1}`}
                      </span>
                    </span>
                    <span className="splitStatusAmount">
                      {checkoutSummary.split_payment.currency}
                      {amount}
                    </span>
                  </div>
                );
              })}
            </div>
          )}

          {/* Item-based split: same paid-history + current-due data as before, just with the
              same Paid / Paying Now labeling for consistency with the equal-split view above. */}
          {splitType !== 'equal' && checkoutSummary.split_payment?.history?.filter(sp => sp.payment_amount > 0).map((sp, i) => (
            <React.Fragment key={i}>
              <hr />
              <div className="splitPaid">
                <div className="sbRow flex-nowrap xsTitle">
                  <span className="lbl">
                    <span className="splitStatusBadge paid">Paid</span>
                    <span>Split {i + 1}</span>
                  </span>
                  <span className="val">
                    {checkoutSummary.split_payment.currency}
                    {sp.payment_amount}
                  </span>
                </div>

                {(Array.isArray(sp.surcharge)
                  ? sp.surcharge
                  : Array.isArray(sp.surcharges)
                  ? sp.surcharges
                  : []
                ).map((s, idx) => (
                  s.surchargeAmountIncluded > 0 && (
                    <div key={idx} className="sbRow flex-nowrap xsTitle">
                      <span className="lbl xsLightText">{s.charge_name}</span>
                      <span className="val">
                        {checkoutSummary.split_payment.currency}
                        {s.surchargeAmountIncluded}
                      </span>
                    </div>
                  )
                ))}
              </div>
            </React.Fragment>
          ))}

          {splitType !== 'equal' && checkoutSummary.split_payment.current?.total_amonut > 0 && (
            <>
              <hr />
              <div className="splitPaid pb-2">
                <div className="sbRow flex-nowrap xsTitle">
                  <span className="lbl">
                    <span className="splitStatusBadge active">Paying Now</span>
                    <span>Current Split</span>
                  </span>
                  <span className="val">
                    {checkoutSummary.split_payment.currency}
                    {checkoutSummary.split_payment.current.total_amonut}
                  </span>
                </div>

                {checkoutSummary.split_payment.current.surcharges?.map((s, i) => (
                  s.surchargeAmountIncluded > 0 && (
                    <div key={i} className="sbRow flex-nowrap xsTitle">
                      <span className="lbl xsLightText">{s.charge_name}</span>
                      <span className="val">
                        {checkoutSummary.split_payment.currency}
                        {s.surchargeAmountIncluded}
                      </span>
                    </div>
                  )
                ))}
              </div>
            </>
          )}

          <hr />
          <div className="splitTotalsSummary">
            <div className="sbRow flex-nowrap xsTitle">
              <span className="lbl">Total Paid</span>
              <span className="val successColor">
                {checkoutSummary.split_payment.currency}
                {totalSplitPaid.toFixed(2)}
              </span>
            </div>
            <div className="sbRow flex-nowrap xsTitle pb-3">
              <span className="lbl fw-semibold">Remaining Balance</span>
              <span className="val fw-semibold">
                {checkoutSummary.split_payment.currency}
                {splitRemainingBalance.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </>
    ) : null
  );


  const PaymentButtons = () => {
    const isEftpos = paymentMethod === PAYMENT_MODES.eftpos;

    return (
    <div className="d-flex flex-column gap-2 mt-3">
      {showEftposButtons && checkoutSummary.linkly.map(pinpad => (
        <button key={pinpad.id} className="btn btn-success" onClick={() => handleEftposPay(pinpad)} disabled={paymentProcessing}>
          {pinpad.pinpad_name}
        </button>
      ))}
      {showPayNow && <button className="btn btn-success" onClick={() => handlePayment(1)} disabled={paymentProcessing}>Pay Now</button>}
      {isEftpos && (
        <button
          className="btn btn-warning"
          onClick={() => handlePayment(1, true)}
          disabled={paymentProcessing}
        >
          Manual EFTPOS
        </button>
      )}
      {showUnpaid && <button className="btn btnPrimary" onClick={() => handlePayment(0)} disabled={paymentProcessing}>Unpaid</button>}
      {showCompleteOrder && <button className="btn btn-success" onClick={() => handlePayment(1)} disabled={paymentProcessing}>Complete Order</button>}
      <button className="btn btnPrimary" onClick={handlePrintBill}>Print Bill</button>
      {showPayTom && (
        <>
        <button
            className="btn btn-danger"
            onClick={handleTomPayment}
          >
            Pay on Tom
          </button>

        <button onClick={downloadTomReport}>
        Download TOM Debug Report
        </button>
        </>
      )}
    </div>
    );
  };

  return (
    <div className="col-lg position-relative">
      {loading && <div className="wave-overlay show" />}
      <div className="cardStyle checkoutSummaryCol">
        <div className="cardHeader"><h4 className="smTitle mb-0">Checkout Summary</h4></div>
        <div className="cardBody">
          <div className="d-flex flex-column gap-3">
            <OrderInfo />
            <SplitPayments />
            {splitPaymentActive && splitType === 'cash_eftpos' && (
              <>
                <hr />
                <div className="pSplitCol">
                  <h4 className="xsTitle mb-2 pb-0">Split Payments Details</h4>
                  <div className="equalSplitSelection">
                    <div className="splitStatusRow active">
                      <span className="splitStatusLabel">
                        <span className="splitStatusBadge active">Paying Now</span>
                        <span>Cash</span>
                      </span>
                      <span className="splitStatusAmount">
                        ${cashAmount || '0.00'}
                      </span>
                    </div>
                    <div className="splitStatusRow pending">
                      <span className="splitStatusLabel">
                        <span className="splitStatusBadge pending">Pending</span>
                        <span>EFTPOS</span>
                      </span>
                      <span className="splitStatusAmount">
                        ${Math.max(0, (Number(checkoutSummary?.net_total) || 0) - (Number(cashAmount) || 0)).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
            {showCalculator && <Calculator />}
            <div className="row g-2 couponFldCol">
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btnPrimary"
                  onClick={() => setShowVoucherModal(true)}
                  disabled={paymentProcessing}
                >
                  Apply Voucher
                </button>
              </div>
              <div className="col-auto">
                <button
                  type="button"
                  className="btn btnPrimary"
                  onClick={() => setShowDiscountModal(true)}
                  disabled={paymentProcessing}
                >
                  Apply Discount
                </button>
              </div>

              {couponMessage && (
                <div className="col-12">
                  <small className="text-primary">{couponMessage}</small>
                </div>
              )}
            </div>

            <ApplyVoucherModal
              isOpen={showVoucherModal}
              onClose={() => setShowVoucherModal(false)}
              coupon={coupon}
              onCouponChange={setCoupon}
              onApply={handleApplyCoupon}
              applying={couponApplying}
              message={couponMessage}
            />

            <ApplyDiscountModal
              isOpen={showDiscountModal}
              onClose={() => setShowDiscountModal(false)}
              onApply={handleApplyManualDiscount}
              applying={false}
            />

            {checkoutSummary?.gratuity_surcharges?.length > 0 && (
              <div className="cardLgCol">
                <h4 className="lgTitle">Add Gratuity</h4>
                <select
                  className="form-select"
                  value={gratuitySurchargeId || ''}
                  disabled={paymentProcessing}
                  onChange={(e) => setGratuitySurchargeId(e.target.value || null)}
                >
                  <option value="">None</option>
                  {checkoutSummary.gratuity_surcharges.map((g) => (
                    <option key={g.id} value={g.id}>
                      {g.charge_name} (${g.total_expenses})
                    </option>
                  ))}
                </select>
              </div>
            )}

            <LoyaltyPoints orderId={orderId} tableId={tableId} onSelect={(amount) => {
              setLoyaltyApplied(amount > 0);
              setLoyaltyAmount(amount);
            }} />
            <PaymentButtons />
          </div>
        </div>
      </div>

      <AddSelectCustomerModal
        isOpen={showCustomerModal}
        onClose={() => setShowCustomerModal(false)}
        orderNumbers={checkoutSummary?.order_number?.join(',')}
        orderType={orderTypeNum}
        onCustomerUpdated={() => {
          fetchCheckoutSummary();
        }}
      />

    </div>
  );
}
